export default __webpack_public_path__ + "static/logo-a35ebfaa32a1c89a7b57c34d7e441f84.svg";